module.exports = __webpack_public_path__ + "img/icon-head-logo.4995956e.png";